<div class="ot-header-bar-progress-container" [ngClass]="messageClass">
  <!-- Progress -->
  <div class="ot-progress-header-content-container ot-progress" *ngIf="hbi.showProgress">
    <div class='ot-progress-header-message'>{{hbi.message}}</div>
    <div class='ot-progress-progress'>
      <file360-progress-bar [value]="details.percentComplete"></file360-progress-bar>
    </div>
    <div class='ot-progress-interaction-container'>
      <button *ngIf="showStop()" class='ot-progress-header-action' (click)="stopAll()">Stop</button>
      <button class='ot-progress-header-caret' (click)="onCaret()"
        [ngClass]="{'ot-up': hbi.showCaretUp, 'ot-down': hbi.showCaretDown}"></button>
    </div>
  </div>

  <!-- No progress -->
  <div class="ot-progress-header-content-container ot-no-progress" *ngIf="!hbi.showProgress">
    <div class='ot-progress-message-container'>
      <img [src]="hbi.icon" class='ot-progress-header-icon'>
      <div class='ot-progress-header-message'>{{hbi.message}}</div>
    </div>
    <div class='ot-progress-error-count' *ngIf="details.errors == 1">{{details.errors}} error</div>
    <div class='ot-progress-error-count' *ngIf="details.errors > 1">{{details.errors}} errors</div>
    <button *ngIf="hbi.showCaretDown || hbi.showCaretUp" class='ot-progress-header-caret' (click)="onCaret()"
      [ngClass]="{'ot-up': hbi.showCaretUp, 'ot-down': hbi.showCaretDown}"></button>
    <button class='ot-progress-header-close' (click)="onClose()"></button>
  </div>

  <!-- Details -->
  <div *ngIf="isExpanded" class="ot-progress-detail-container">
    <div *ngFor="let detail of details.details" class="ot-progress-item"
      [ngClass]="{'ot-status-action': detail.state == ProgressDetailState.Waiting || detail.state == ProgressDetailState.Done || detail.state == ProgressDetailState.Error, 'ot-done': detail.state == ProgressDetailState.Done, 'ot-canceled' : detail.state == ProgressDetailState.Canceled, 'ot-error' : detail.state == ProgressDetailState.Error }">
      <div class='ot-progress-detail-message-container'>
        <img class="ot-progress-detail-icon" [src]="detail.icon">
        <div class='ot-progress-detail-message-text'>{{detail.message}}</div>
      </div>
      <!-- No progress-->
      <div *ngIf="detail.state != ProgressDetailState.InProgress" class='ot-progress-status-text'
        [title]="detail.statusText">{{detail.statusText}}
      </div>
      <!-- Progress-->
      <div *ngIf="detail.state == ProgressDetailState.InProgress" class='ot-progress-status-progress'>
        <file360-progress-bar [value]="detail.percentComplete"></file360-progress-bar>
      </div>
      <!-- Cancel button only when waiting or in progress -->
      <button *ngIf="detail.state == ProgressDetailState.Waiting || detail.state == ProgressDetailState.InProgress"
        class='ot-progress-cancel' (click)="stop(detail)"></button>
      <!-- Done or Error -->
      <img *ngIf="detail.state == ProgressDetailState.Done || detail.state == ProgressDetailState.Error"
        class='ot-progress-status-icon' [src]="ProgressDetailTypeIcons[detail.state]">
    </div>
  </div>
</div>